<template>
  <div class="ic-modal-body">
    <h2 class="ic-modal-body__title">{{ heading }}</h2>
    <p v-if="errorBody" class="ic-modal-body__error-body" v-text="errorBody" />
    <p>{{ deletePaymentQuestion }}</p>
    <div class="payment-info" v-if="payment">
      <div class="payment-info__processor">
        <img
          class="payment-info__img"
          :class="getPaymentClass({ type: payment.type })"
          :src="handlePaymentImage(payment.type)"
          alt="The logo of the payment processor for the payment card on file"
        />
      </div>
      <ul
        class="payment-info__details"
        :class="{
          'payment-info__details--two-col': /sprel|paypal/.test(payment.type)
        }"
      >
        <li v-if="cardName" class="payment-info__container-column">
          <h3 class="payment-info__title">
            <span v-if="!/sprel|paypal/.test(payment.type)">Cardholder </span
            >Name
          </h3>
          <span class="payment-info__content">
            {{ cardName }}
          </span>
        </li>
        <li
          v-if="!/sprel|paypal/.test(payment.type)"
          class="payment-info__container-column"
        >
          <h3 class="payment-info__title">Card Number</h3>
          <span class="payment-info__content">
            **** **** **** {{ payment.card_check_digit }}
          </span>
        </li>
        <li
          v-if="payment.kind && payment.kind.toLowerCase() === 'paypal'"
          class="payment-info__container-column"
        >
          <h3 class="payment-info__title">Email</h3>
          <span class="payment-info__content">
            {{ getPaypalEmail({ paypalPayment: payment }) }}</span
          >
        </li>
        <li
          v-if="!/sprel|paypal/.test(payment.type)"
          class="payment-info__container-column"
        >
          <h3 class="payment-info__title">Expiration Date</h3>
          <span class="payment-info__content">
            {{ payment.expire_month }}/{{ payment.expire_year }}
          </span>
        </li>
      </ul>
    </div>
    <div class="ic-modal-body__form-buttons">
      <button
        class="ic-modal-body__form-button"
        :class="{
          'ic-modal-body__form-button--loading': isProcessingDelete
        }"
        v-touch:tap="deletePaymentInfo"
      >
        {{ deleteButtonText }}
      </button>
      <button
        class="ic-modal-body__form-button ic-modal-body__form-button--cancel"
        :disabled="isProcessingDelete"
        v-touch:tap="closeModal"
      >
        {{ cancelButtonText }}
      </button>
    </div>
  </div>
</template>

<script>
import imagePaypal from 'assets/images/shared/paypal.svg';
import getPaypalEmail from '@/assets/js/shared/helpers/getPaypalEmail';
import billingSDK from '@/assets/js/shared/services/billing-sdk';
import getPaymentClass from '@/assets/js/helpers/getPaymentClass';

const imageVisa = require('@/assets/images/shared/payment-processors/visa.svg');
const imageMastercard = require('@/assets/images/shared/payment-processors/mastercard.svg');

export default {
  name: 'ic-delete-payment',
  props: {
    userId: {
      type: String
    },
    heading: {
      type: String
    },
    deletePaymentQuestion: {
      type: String
    },
    payment: {
      type: Object
    },
    cardName: {
      type: String
    },
    cardImage: {
      type: String
    },
    deleteButtonText: {
      type: String
    },
    cancelButtonText: {
      type: String
    },
    domain: {
      type: String
    },
    billingVersion: {
      type: String,
      default: 'v1'
    }
  },
  methods: {
    getPaymentClass,
    /**
     * Pass in type of credit card to get back appropriate image
     * @param type
     * @returns {*}
     */
    handlePaymentImage(type) {
      switch (type) {
        case 'master':
        case 'mastercard':
          return imageMastercard;
        case 'paypal':
        case 'sprel':
          return imagePaypal;
        default:
          return imageVisa;
      }
    },
    /**
     * Submits delete current user's payment
     */
    async deletePaymentInfo($event) {
      $event.preventDefault();
      this.isProcessingDelete = true;
      try {
        if (this.billingVersion !== 'v2') {
          await billingSDK(window).Billing.Payments.deleteByAccount(
            this.domain,
            this.userId,
            this.payment.id
          );
        } else {
          await this.$billingProcessorSDK.Payment.removeByAccount(
            this.domain,
            this.userId,
            this.payment.id
          );
        }

        this.$emit('delete-payment', this.payment.id);
        this.closeModal();
      } catch (err) {
        this.errorBody = 'Error deleting payment method';
        console.error(err);
        this.$bugsnag?.notify(err);
      }
      this.isProcessingDelete = false;
    },
    /**
     * Closes modal
     */
    closeModal() {
      this.$emit('ic-account-modal-close');
    }
  },
  data() {
    return {
      isDeleteModalOpen: false,
      isProcessingDelete: false,
      errorBody: null,
      getPaypalEmail
    };
  }
};
</script>
